module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-bonuses-64-active.7369748e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-bonuses-64-active.png
// module id = 3186
// module chunks = 11